const translations = {
  ja: {
    language: {
      label: '表示言語を選択',
      japanese: '日本語',
      chinese: '中文',
      english: 'English',
    },
    common: {
      home: 'ホーム',
      teacher: '先生',
      details: '詳細はこちら',
      close: '閉じる',
      contact: 'お問い合わせ',
    },
    nav: {
      home: 'ホーム',
      volunteer: 'ボランティア',
      teachers: '日本語先生',
      volunteerRecruitment: 'ボランティア募集',
      japaneseClass: '日本語教室',
      cookingClass: '料理教室',
      nextCookingClass: '次の料理教室（未定）',
      pastCookingClasses: '過去の料理教室',
      events: 'イベント',
      eventHistory: 'イベント履歴',
      contact: 'お問い合わせ',
      addLineFriend: 'LINE友だち追加',
    },
    home: {
      title: '日本語教室',
      name: 'ボラボラ',
      intro: '参加者のレベルにより、初級・中級・上級のグループに分かれて学習しています。日本語を学びながら、楽しい国際交流ができます。',
      learningScene: '学習中の様子',
      freeParticipation: '参加自由',
      entryNotice: '※入退室は自由ですが、必ずお声掛けをお願いします',
      contactSuzuki: '連絡方法：鈴木先生（日本語対応）',
      contactLiu: '劉さん（中国語対応）',
      coordinator: '担当者：鈴木 弥',
      address: '住所：にこわ新小岩 3階　東京都葛飾区西新小岩4-33-2',
      volunteerButton: 'ボランティアの先生を募集します！詳細はこちら →',
      volunteerTitle: 'ボランティアの先生を募集します！',
      volunteerLines: [
        '年齢は問いません。壮年・シニアのボランティアが中心ですが、18歳の女性ボランティア先生もいます。',
        '資格も必要ありません。外国の方と日本語を通じて交流したいという意欲があれば、どなたでも参加できます。文法など細かいことを忘れていても大丈夫です。',
        '私たちは日本語のプロです。それぞれのボランティアの方が、自分のスタイルで自由に学習者へ教えてください。',
        '困ったときは他のボランティアの先生がお手伝いします。最初は先生の補佐として学習を進めていただいても構いません。',
        'ぜひ私たちと一緒に、日本語を教えながら交流を深めていきましょう。ご希望の方は代表の鈴木までメールでご連絡ください。',
      ],
    },
    japaneseClass: {
      audience: '日本で生活している外国人向け',
      title: '「ボラボラ」日本語教室',
      description: 'テキストを使った少人数レッスンや、可能な場合はマンツーマン授業も行います。この教室の特徴は、テーブルを囲み、会話を中心に学ぶことです。レベルに合わせて会話をし、難しい方には少人数で個別に教えます。交流会や外出、花見なども楽しみます。\n\nボランティアの先生が少ない場合もありますが、教室時間外でも可能な限りSNSや電話で質問を受け付けます。勉強以外の相談にも対応し、日本語能力試験の学習も支援します。',
      join: '参加したい',
    },
    cooking: {
      title: '料理教室',
      together: '一緒に作りましょう',
      description: '毎月最初の金曜日、みんなで料理を作り、食べながら楽しく会話します。',
      sectionTitle: '一緒に料理を作りましょう',
      dishes: ['すいとん', 'ちらし寿司', 'カレー', 'うなぎ', 'どじょう'],
      items: {
        1: { title: 'うなぎ', description: '値段が高い' },
        2: { title: 'すいとん', description: 'すいとんとは、小麦粉の生地をひと口大にして、だし汁で煮込む料理です。' },
        3: { title: 'ちらし寿司', description: '酢飯を器に平たく盛り付け、準備した具材を順にのせていきます。' },
        4: { title: '餃子', description: 'キムチ餃子、豚肉ニラ餃子、鶏肉キノコ餃子、エビと卵の餃子。' },
        5: { title: '銀杏', description: '家庭では電子レンジと紙封筒を使うと、短時間でむらなく加熱できます。' },
        6: { title: 'カレー', description: '長時間煮込むカレーには、熱が均一に伝わり保温性にも優れた厚手の鍋が向いています。' },
      },
    },
    teachers: {
      pageTitle: 'ボランティア',
      pageSubTitle: '日本語先生',
      eyebrow: 'ボランティアたち',
      heading: '日本語先生',
      role: '先生',
      recruitmentTitle: 'ボラボラ募集',
      recruitmentSubTitle: '先生',
      recruitmentHeading: '日本語を教えたい方へ',
      recruitmentText: '教え方に決まりはありません。ご自身の考えやスタイルで自由に教えていただけます。問題や困ったことがあれば、他のボランティアが一緒に支え、協力します。趣味の延長として参加したり、外国の友達を作るきっかけにしたりしてみませんか。',
      names: {
        1: '鈴木 mitsu',
        2: '村山 yuriko',
        3: '前田 kyoko',
        4: '八木 mami',
        5: '日野 susumu',
        6: '阿部 kenta',
        7: '吉野 sachiko',
        8: '品田 yuna',
      },
    },
    events: {
      pageTitle: 'イベント履歴',
      pageSubTitle: 'イベント',
      eyebrow: '私たちのイベント',
      heading: 'イベントギャラリー',
      items: {
        1: { title: '高尾山に登る会', location: '高尾山', date: '11月' },
        2: { title: '葛西臨海公園BBQ', location: '葛西臨海公園', date: '8月' },
        3: { title: '葛飾区花火大会', location: '葛飾区', date: '7月' },
        4: { title: '新小岩公園の夜桜', location: '新小岩公園', date: '3月' },
        5: { title: 'スカイダック', location: 'お台場', date: '11月' },
        6: { title: '横浜中華街の忘年会', location: '横浜', date: '12月' },
      },
    },
    contact: {
      pageTitle: 'お問い合わせ',
      pageSubTitle: '連絡先',
      addressTitle: '住所',
      venue: '会場：にこわ新小岩 3階',
      address: '東京都葛飾区西新小岩4-33-2',
      access: 'JR「新小岩」駅北口から徒歩8分',
      contactTitle: '連絡先',
      suzuki: '鈴木先生（日本語対応）',
      email: 'メール',
      phone: '電話',
      liu: '劉さん（中国語対応）',
      hoursTitle: '活動時間',
      hours: '毎週金曜日 19:00〜20:45',
      holidays: '祝日は休み',
      fee: '費用：無料',
    },
    footer: {
      rights: '© 2023 Borabora. All rights reserved.',
      privacy: 'プライバシーポリシー',
      terms: '利用規約',
      about: '私たちについて',
      faq: 'よくある質問',
    },
  },
  zh: {
    language: {
      label: '选择显示语言',
      japanese: '日本語',
      chinese: '中文',
      english: 'English',
    },
    common: {
      home: '首页',
      teacher: '老师',
      details: '查看详情',
      close: '关闭',
      contact: '联系我们',
    },
    nav: {
      home: '首页',
      volunteer: '志愿者',
      teachers: '日语老师',
      volunteerRecruitment: '招募志愿者',
      japaneseClass: '日语教室',
      cookingClass: '料理教室',
      nextCookingClass: '下次料理教室（待定）',
      pastCookingClasses: '往期料理教室',
      events: '活动',
      eventHistory: '活动记录',
      contact: '联系我们',
      addLineFriend: '添加 LINE 好友',
    },
    home: {
      title: '日语教室',
      name: 'Borabora',
      intro: '我们会根据参加者的日语水平分为初级、中级和高级小组。大家可以一边学习日语，一边进行愉快的国际交流。',
      learningScene: '学习现场',
      freeParticipation: '自由参加',
      entryNotice: '※可自由进出，但进出时请务必告知老师',
      contactSuzuki: '联系方式：铃木老师（日语）',
      contactLiu: '刘先生（中文）',
      coordinator: '负责人：铃木 弥',
      address: '地址：NIKOWA 新小岩 3楼　东京都葛饰区西新小岩4-33-2',
      volunteerButton: '正在招募志愿者老师！点击查看详情 →',
      volunteerTitle: '招募志愿者老师！',
      volunteerLines: [
        '年龄不限。目前以中壮年和老年志愿者为主，也有18岁的女性志愿者老师。',
        '无需任何资格证。只要愿意通过日语与外国朋友交流，任何人都可以参加。即使忘记了一些语法细节也没有关系。',
        '我们都是日语的母语使用者。每位志愿者都可以按照自己的方式，自由地指导学习者。',
        '遇到困难时，其他志愿者老师会提供帮助。刚开始时，也可以先作为老师的助手参与教学。',
        '欢迎和我们一起，在教授日语的同时加深交流。有意者请通过邮件联系负责人铃木老师。',
      ],
    },
    japaneseClass: {
      audience: '面向在日本生活的外国人',
      title: '“Borabora”日语教室',
      description: '我们会使用教材开展小班课程，在条件允许时也会进行一对一教学。本教室最大的特色是大家围坐在桌旁，以会话为中心学习。我们会根据不同水平练习会话，对会话有困难的学习者进行小班或个别辅导。此外还会举办交流会、一起外出，樱花季也会去附近公园赏花。\n\n志愿者老师有时人数较少，但在教室时间之外，我们也会尽可能通过社交软件或电话回答问题。学习以外的问题也可以咨询，我们还会协助准备日语能力考试。',
      join: '我想参加',
    },
    cooking: {
      title: '料理教室',
      together: '一起动手做吧',
      description: '每月第一个星期五，大家会在料理教室一起做饭，并边吃边愉快地交流。',
      sectionTitle: '一起做料理吧',
      dishes: ['日式面疙瘩汤', '散寿司', '咖喱', '鳗鱼', '泥鳅'],
      items: {
        1: { title: '鳗鱼', description: '价格较高。' },
        2: { title: '日式面疙瘩汤', description: '把小麦面团做成一口大小，放入高汤中煮熟的一道料理。' },
        3: { title: '散寿司', description: '将醋饭平铺在容器中，再依次摆上准备好的配料。' },
        4: { title: '饺子', description: '泡菜饺子、猪肉韭菜饺子、鸡肉蘑菇饺子，以及虾仁鸡蛋饺子。' },
        5: { title: '银杏', description: '在家中可使用微波炉和纸袋，轻松、快速且均匀地加热。' },
        6: { title: '咖喱', description: '长时间炖煮咖喱时，厚底锅受热均匀、保温性好，更适合使用。' },
      },
    },
    teachers: {
      pageTitle: '志愿者',
      pageSubTitle: '日语老师',
      eyebrow: '我们的志愿者',
      heading: '日语老师',
      role: '老师',
      recruitmentTitle: 'Borabora 志愿者招募',
      recruitmentSubTitle: '老师',
      recruitmentHeading: '致想教日语的朋友',
      recruitmentText: '教学方式没有固定规则，您可以按照自己的想法和风格自由教学。遇到问题或困难时，其他志愿者会共同支持与协助。不妨把志愿活动当作兴趣的延伸，或把它当成结识外国朋友的机会。',
      names: {
        1: '铃木 Mitsu',
        2: '村山 Yuriko',
        3: '前田 Kyoko',
        4: '八木 Mami',
        5: '日野 Susumu',
        6: '阿部 Kenta',
        7: '吉野 Sachiko',
        8: '品田 Yuna',
      },
    },
    events: {
      pageTitle: '活动记录',
      pageSubTitle: '活动',
      eyebrow: '我们的活动',
      heading: '活动相册',
      items: {
        1: { title: '高尾山登山会', location: '高尾山', date: '11月' },
        2: { title: '葛西临海公园烧烤', location: '葛西临海公园', date: '8月' },
        3: { title: '葛饰区烟花大会', location: '葛饰区', date: '7月' },
        4: { title: '新小岩公园夜樱', location: '新小岩公园', date: '3月' },
        5: { title: 'Sky Duck 水陆两用巴士', location: '台场', date: '11月' },
        6: { title: '横滨中华街年末聚会', location: '横滨', date: '12月' },
      },
    },
    contact: {
      pageTitle: '联系我们',
      pageSubTitle: '联系方式',
      addressTitle: '地址',
      venue: '会场：NIKOWA 新小岩 3楼',
      address: '东京都葛饰区西新小岩4-33-2',
      access: '从 JR 新小岩站北口步行8分钟',
      contactTitle: '联系方式',
      suzuki: '铃木老师（日语）',
      email: '邮箱',
      phone: '电话',
      liu: '刘先生（中文）',
      hoursTitle: '活动时间',
      hours: '每周五 19:00–20:45',
      holidays: '节假日休息',
      fee: '费用：免费',
    },
    footer: {
      rights: '© 2023 Borabora. 保留所有权利。',
      privacy: '隐私政策',
      terms: '使用条款',
      about: '关于我们',
      faq: '常见问题',
    },
  },
  en: {
    language: {
      label: 'Choose display language',
      japanese: '日本語',
      chinese: '中文',
      english: 'English',
    },
    common: {
      home: 'Home',
      teacher: 'Teacher',
      details: 'Learn more',
      close: 'Close',
      contact: 'Contact',
    },
    nav: {
      home: 'Home',
      volunteer: 'Volunteers',
      teachers: 'Japanese Teachers',
      volunteerRecruitment: 'Become a Volunteer',
      japaneseClass: 'Japanese Class',
      cookingClass: 'Cooking Class',
      nextCookingClass: 'Next Class (TBD)',
      pastCookingClasses: 'Past Cooking Classes',
      events: 'Events',
      eventHistory: 'Event History',
      contact: 'Contact',
      addLineFriend: 'Add us on LINE',
    },
    home: {
      title: 'Japanese Class',
      name: 'Borabora',
      intro: 'Participants study in beginner, intermediate, and advanced groups according to their level. Learn Japanese while enjoying friendly international exchange.',
      learningScene: 'Our class in action',
      freeParticipation: 'Drop in anytime',
      entryNotice: '※ You may come and go freely, but please let a teacher know.',
      contactSuzuki: 'Contact: Mr. Suzuki (Japanese)',
      contactLiu: 'Mr. Liu (Chinese)',
      coordinator: 'Coordinator: Mitsu Suzuki',
      address: 'Address: Nikowa Shinkoiwa, 3F, 4-33-2 Nishi-Shinkoiwa, Katsushika-ku, Tokyo',
      volunteerButton: 'Volunteer teachers wanted! Learn more →',
      volunteerTitle: 'Volunteer Teachers Wanted!',
      volunteerLines: [
        'There is no age limit. Most volunteers are middle-aged or senior, and we also have an 18-year-old volunteer teacher.',
        'No qualifications are required. Anyone who wants to connect with people from other countries through Japanese is welcome. It is fine if you have forgotten some grammar details.',
        'As native Japanese speakers, we each have something valuable to share. Volunteers are free to teach learners in their own style.',
        'Other volunteer teachers will help whenever you need support. You may also begin by assisting another teacher.',
        'Join us in building friendships while teaching Japanese. If you are interested, please contact our representative, Mr. Suzuki, by email.',
      ],
    },
    japaneseClass: {
      audience: 'For international residents living in Japan',
      title: 'Borabora Japanese Class',
      description: 'We use textbooks, teach in small groups, and offer one-to-one lessons when possible. What makes our class special is learning through conversation around a shared table. We adapt conversations to each level and provide small-group or individual support when needed. We also hold social gatherings, go on outings, and enjoy cherry blossoms in a nearby park.\n\nVolunteer numbers can sometimes be limited, but we answer questions through social media or by phone outside class whenever possible. We also help with everyday concerns and preparation for the Japanese-Language Proficiency Test.',
      join: 'I want to join',
    },
    cooking: {
      title: 'Cooking Class',
      together: 'Let’s cook together',
      description: 'On the first Friday of each month, we cook together and enjoy conversation over the meal.',
      sectionTitle: 'Let’s Cook Together',
      dishes: ['Suiton soup', 'Chirashi sushi', 'Curry', 'Eel', 'Loach'],
      items: {
        1: { title: 'Eel', description: 'A delicious but relatively expensive ingredient.' },
        2: { title: 'Suiton Soup', description: 'A comforting soup made by simmering bite-sized pieces of wheat-flour dough in broth.' },
        3: { title: 'Chirashi Sushi', description: 'Sushi rice is spread in a dish and topped with a colorful selection of prepared ingredients.' },
        4: { title: 'Gyoza', description: 'Kimchi, pork and chive, chicken and mushroom, and shrimp and egg dumplings.' },
        5: { title: 'Ginkgo Nuts', description: 'At home, a microwave and paper envelope make them quick and easy to heat evenly.' },
        6: { title: 'Curry', description: 'A heavy pot distributes heat evenly and retains warmth, making it ideal for long-simmered curry.' },
      },
    },
    teachers: {
      pageTitle: 'Volunteers',
      pageSubTitle: 'Japanese Teachers',
      eyebrow: 'Our volunteers',
      heading: 'Japanese Teachers',
      role: 'Teacher',
      recruitmentTitle: 'Borabora Volunteers',
      recruitmentSubTitle: 'Teacher',
      recruitmentHeading: 'For anyone who would like to teach Japanese',
      recruitmentText: 'There is no fixed teaching method. You are welcome to teach freely in your own style. If you run into a problem, fellow volunteers will support and help you. Why not volunteer as an extension of your interests—or simply as an opportunity to make friends from around the world?',
      names: {
        1: 'Mitsu Suzuki',
        2: 'Yuriko Murayama',
        3: 'Kyoko Maeda',
        4: 'Mami Yagi',
        5: 'Susumu Hino',
        6: 'Kenta Abe',
        7: 'Sachiko Yoshino',
        8: 'Yuna Shinada',
      },
    },
    events: {
      pageTitle: 'Event History',
      pageSubTitle: 'Events',
      eyebrow: 'Our events',
      heading: 'Event Gallery',
      items: {
        1: { title: 'Mt. Takao Hiking Day', location: 'Mt. Takao', date: 'Nov' },
        2: { title: 'Kasai Rinkai Park BBQ', location: 'Kasai Rinkai Park', date: 'Aug' },
        3: { title: 'Katsushika Fireworks Festival', location: 'Katsushika', date: 'Jul' },
        4: { title: 'Evening Cherry Blossoms', location: 'Shinkoiwa Park', date: 'Mar' },
        5: { title: 'Sky Duck Tour', location: 'Odaiba', date: 'Nov' },
        6: { title: 'Year-end Gathering in Chinatown', location: 'Yokohama', date: 'Dec' },
      },
    },
    contact: {
      pageTitle: 'Contact Us',
      pageSubTitle: 'Contact',
      addressTitle: 'Address',
      venue: 'Venue: Nikowa Shinkoiwa, 3F',
      address: '4-33-2 Nishi-Shinkoiwa, Katsushika-ku, Tokyo',
      access: '8 minutes on foot from the north exit of JR Shinkoiwa Station',
      contactTitle: 'Contact',
      suzuki: 'Mr. Suzuki (Japanese)',
      email: 'email',
      phone: 'phone',
      liu: 'Mr. Liu (Chinese)',
      hoursTitle: 'Class Hours',
      hours: 'Every Friday, 7:00–8:45 PM',
      holidays: 'Closed on public holidays',
      fee: 'Fee: Free',
    },
    footer: {
      rights: '© 2023 Borabora. All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms',
      about: 'About Us',
      faq: 'FAQ',
    },
  },
};

export default translations;
